
  import {Component, Vue} from 'vue-property-decorator';
  import {
    Action,
    Getter,
  } from 'vuex-class';

  import {mapActions} from 'vuex';

  @Component
  export default class SignUp extends Vue {
    public $refs!: {
      form: any,
    };

    private user: any = {};
    private loading: boolean = false;
    @Getter('common/rules/all') private rules!: any;

    @Action('guest/auth/signUp') private storeSignUp!: (user: any) => Promise<boolean>;

    private signUp(e: Event): void {
      e.preventDefault();
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.storeSignUp(this.user)
          .then((success) => {
            this.loading = false;
            if (success) {
              this.$router.push({name: 'ConfirmSignUp'});
            }
          });
      }
    }
  }
